import React, {useContext, useEffect, useState} from 'react';
import 'url-search-params-polyfill'; // for IE
import {CustomForm, Loader, EntryComponent, ResultsComponent} from './components';
import {ResultsPage} from './components/ResultsPage';
import {useMediaQuery} from 'react-responsive';
import GlobalContextProvider, {GlobalContext} from './context';
import {DEBUG_MODE, defaultConfig} from './config';
import {testChangeResponseValues, testConditions} from './tests';

export const App = () => {
    const isTabletOrMobile = useMediaQuery({query: '(max-width: 999px)'});
    const [isTenant, setIsTenant] = useState(false);

    const {
        pending,
        showForm,
        showResultsPage,
        goToResults,
        handleSubmitForm,
    } = useContext(
        GlobalContext);

    if (pending) {
        return <Loader/>;
    }

    if (showForm) {
        return (
            <div>
                <div
                    id="maincontainer"
                    className={isTabletOrMobile ?
                        'sm-view container col-lg-10 col-12' :
                        'container col-lg-10 col-12'}>
                    <CustomForm
                        handleSubmitForm={handleSubmitForm}
                        handleBackToResults={goToResults}
                    />
                </div>
            </div>
        );
    } else if (showResultsPage) {
        return (
            <div>
                <div
                    id="maincontainer"
                    className={isTabletOrMobile ?
                        'sm-view container col-lg-10 col-12' :
                        'container col-lg-10 col-12'}>
                    <ResultsComponent
                        isTabletOrMobile={isTabletOrMobile}
                    />
                </div>
            </div>
        );
    }

    return (
        <div>
            <div
                className={isTabletOrMobile ?
                    'sm-view container col-12' :
                    'container col-12'}>
                <>
                    {!isTenant ? (
                        <EntryComponent/>
                    ) : (
                        <div style={{
                            marginBottom: 20, display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column'
                        }}>
                            <div style={{marginTop: 20, marginBottom: 20}}>Bitte wenden Sie sich bzgl. Ihrer
                                Heizungssanierung an
                                den
                                Eigentümer der Immobilie.
                            </div>

                            <button
                                className="buttonHighlight"
                                onClick={() => setIsTenant(false)}
                            >Zurück</button>

                        </div>)
                    }
                </>
            </div>
        </div>
    );
};

export default () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const configUrl = params.get('configUrl');

    const [configuration, setConfiguration] = useState(null);
    const [key] = useState(null); // Maybe needs to be injected in Service
    const [configId, setConfigId] = useState(null);

    // TURNING OFF ALL CONSOLE LOGS
    if(!DEBUG_MODE) {
        console.log = function () {
        };
    }
    // TESTS
    testConditions();
    testChangeResponseValues();
    useEffect(() => {
        (async () => {
            if (configUrl) {
                const result = await fetch(configUrl, {
                    method: 'get',
                    headers: {'Content-Type': 'application/json'},
                });
                const remoteConfiguration = await result.json();
                setConfiguration(remoteConfiguration);
                setConfigId(remoteConfiguration.id);
            } else {
                const fixedConfigData = params.get('configData');
                if (fixedConfigData) {
                    const defaultConfig = JSON.parse(fixedConfigData);
                    setConfigId(defaultConfig.id);
                    setConfiguration(defaultConfig);
                } else {
                    setConfiguration(defaultConfig);
                }
            }
        })();
    }, []);

    // Overwrite colors from remote
    useEffect(() => {
        if (configuration) {
            let root = document.documentElement;
            root.style.setProperty('--highlight-color-1',
                configuration.colors.highlight1);
            root.style.setProperty('--highlight-color-2',
                configuration.colors.highlight2);
            root.style.setProperty('--background-color',
                configuration.colors.background);
            root.style.setProperty('--accent-color-1',
                configuration.colors['accent_1']);
            root.style.setProperty('--accent-color-2',
                configuration.colors['accent_2']);
            root.style.setProperty('--accent-color-3',
                configuration.colors['accent_3']);
            root.style.setProperty('--font-color', configuration.colors.font);
        }
    }, [configuration]);

    if (!configuration) {
        return <div className="spinner">
            <div className="double-bounce1"/>
            <div className="double-bounce2"/>
        </div>;
    }

    // set config id
    configuration.id = configId;

    return (
        <GlobalContextProvider config={configuration}>
            <App/>
        </GlobalContextProvider>
    );
};
